import { render, staticRenderFns } from "./panel-twitter-settings.vue?vue&type=template&id=3d5c8097&"
import script from "./panel-twitter-settings.vue?vue&type=script&lang=js&"
export * from "./panel-twitter-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports